/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { GoalsAndInterventionsViewModel } from './GoalsAndInterventionsViewModel'; 

export function getGoalsAndInterventionsByOrderOptions(orderId: string, onSuccess?: (result: GoalsAndInterventionsViewModel) => void) {
	return queryOptions({
		queryKey: ['goals-and-interventions-by-order', orderId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/careplanning/goalsandinterventions/queries/getgoalsandinterventionsbyorder/' + orderId;
			const resp = await axios.get<GoalsAndInterventionsViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(orderId)
	});
}